const TaxIugu = {
  PIX: 0.5, // R$ 0,50
  ALL: 1.89, // R$ 1,89
  CARD: 0.0235, // 2.35%
  TRANSACTION: 0.3, // R$ 0,30
};

export default TaxIugu;

export function calculateProfit(type, priceProduct, costPrice, tax) {

  if (!tax || !costPrice || !type || !priceProduct) return 0;

  const differenceValue = priceProduct - costPrice;
  const taxMoney = (tax / 100) * differenceValue;
  const profit = differenceValue - taxMoney;

  if (type =='profit') {
    return profit;
  }

  const applyPercentage = (value) =>
    parseFloat(((value / priceProduct) * 100).toFixed(2));

  const calculateResult = (deduction) => profit - deduction;

  const deductions = {
    pix: TaxIugu.PIX,
    all: TaxIugu.ALL,
    card: profit * TaxIugu.CARD,
  };

  if (type.endsWith('Percentage')) {
    const key = type.replace('Percentage', '');
    
    if(key == 'profit') {
      return applyPercentage(profit);
    }
    return applyPercentage(calculateResult(deductions[key]));
  }

  if (deductions[type]) {
    return calculateResult(deductions[type]);
  }

  return 0;
}